<!--
 * @Author: 孙照
 * @LastEditTime: 2024-01-05 11:02:19
 * @Description: 光伏发电量统计
 * @FilePath: \sheyang\src\module\overview\rightContent\evEleStat.vue
-->
<template>
  <div class="ev-ele-stat">
    <div style="width: 100%;cursor: pointer" @click="handleNavGo">
      <pub-info-title :title="'近30日光伏发电量统计'" />
    </div>
    <div class="content">
      <div ref="evBar" id="evBar"></div>
      <!-- <pub-info-list-item :label="'累计发电量'" :value="totalPvPowerString" /> -->
    </div>
  </div>
</template>

<script>
import * as Echarts from 'echarts';
import pubInfoTitle from '@/components/infoTitle/index.vue';

export default {
  name: 'evEleStat',
  components: {
    pubInfoTitle,
  },
  props: {
    dateData: {
      type: Array,
      default: () => [],
    },
    pvPowerData: {
      type: Array,
      default: () => [],
    },
    totalPvPower: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    totalPvPowerString() {
      return `${this.totalPvPower.toFixed(2)}kWh`;
    },
  },
  data() {
    return {
      chart: null, // 实例
    };
  },
  watch: {
    pvPowerData: {
      deep: true,
      handler() {
        this.barChartsInit();
      },
    },
  },
  mounted() {
    this.barChartsInit();
    window.addEventListener('resize', () => {
      this.chart.resize();
    });
  },
  methods: {
    barChartsInit() {
      const fakeData = [115.59, 84.26, 434.18, 559.03, 570.33, 598.36, 195.71, 399.96, 528.27, 490.85, 466.77, 575.87, 539.84, 540.85, 278.71, 487.94, 569.21, 436.99, 587.29, 430.39, 570.43, 399.41, 359.12, 589.34, 579.49, 567.36, 613.25, 584.87, 594.36, 463.61, 329.09];
      this.chart = Echarts.init(this.$refs.evBar);
      const option = {
        tooltip: {
          trigger: 'axis',
          formatter: (params)=>{
            let str=`<div>${params[0].name}</div>`
            params.forEach(item => {
              str+=`<div style='display:flex;'>
                      <div>${item.marker} </div>
                      <div style='width:90px'>${item.seriesName}</div>
                      <div style='font-weight:600;'>${(item.value).toFixed(0)}</div>
                    </div>`
            });
            return str
          }
        },
        grid: {
          top: this.fitChartSize(30),
          left: 0,
          right: 0,
          bottom: 0,
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          boundaryGap: ['5%', '5%'],
          data: this.dateData,
          axisTick: {
            show: false, // x 轴刻度是否显示
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            color: '#9A9A9A',
            fontSize: this.fitChartSize(12),
            margin: this.fitChartSize(14),
          },
        },
        yAxis: {
          name: 'kWh',
          nameLocation: 'end',
          nameTextStyle: {
            color: '#FFF',
            align: 'right',
            fontSize: this.fitChartSize(12),
            padding: [0, this.fitChartSize(4), 0, 0],
          },
          type: 'value',
          // max(value) { // 取最大值向上取整为最大刻度
          //   return Math.ceil(value.max) < 200 ? 200 : Math.ceil(value.max);
          // },
          // interval: 100,
          axisLabel: {
            color: '#C5C5C5',
            fontSize: this.fitChartSize(12),
            margin: this.fitChartSize(16),
          },
          splitLine: {
            show: true,
            lineStyle: {
              width: 1,
              color: 'rgba(43, 196, 255, 0.5)',
              type: 'dashed',
            },
          },
        },
        series: [
          {
            name: '发电量',
            type: 'bar',
            barWidth: this.fitChartSize(12),
            itemStyle: {
              color: Echarts.graphic.LinearGradient(0, 0, 0, 1, [{ // 代表渐变色从正上方开始
                offset: 0, // offset范围是0~1，用于表示位置，0是指0%处的颜色
                color: 'rgba(135, 233, 255, 1)',
              }, // 柱图渐变色
              {
                offset: 1, // 指100%处的颜色
                color: 'rgba(79, 207, 255, 0)',
              },
              ]),
            },
            // data: this.pvPowerData,
            data: fakeData,
          },
        ],
      };
      this.chart.setOption(option);
    },
    handleNavGo() {
      this.$emit('handleNavGo');
    },
  },
};

</script>

<style lang="less" scoped>
.ev-ele-stat {
  box-sizing: border-box;
  .content {
    box-sizing: border-box;
    width: 100%;
    height: 280px;
    padding-top: 20px;
    #evBar {
      box-sizing: border-box;
      width: 100%;
      height: 200px;
      padding-left: 4px;
      margin-bottom: 19px;
    }
  }
}
</style>
